<template>
  <div class="solutions">

    <div id="our-solutions" class="our-solutions"></div>

    <!-- TITLE -->
    <h1 class="solution-heading">Explore Solutions</h1>

    <!-- SVG BLOB SHAPE -->
    <!-- <Blob></Blob> -->

    <div class="-wrapper">

      <a :href="solution.link" v-for="solution in List" class="-item" v-on:click="solutionClickEvent(solution.name)">
        <i :class="`icon ${solution.iconClass}`" v-html="solution.icon"></i>
        <span class="solution-name">{{ solution.name }}</span>
      </a>

    </div>

  </div>
</template>

<script>

import Blob from './blob'

import eventDispatcher from '../../../events/dispatch'

export default {
  data() {
    return {
      List: [
        {
          name: 'Big Box Ecommerce ',
          icon: '🛒',
          iconClass: 'icon-5',
          link: '/attach/big-box-ecommerce'
        },
        {
          name: 'Beauty & Personal Care',
          icon: '💄',
          iconClass: 'icon-2',
          link: '/attach/beauty'
        },
        {
          name: 'Direct to Consumer Brands',
          icon: '📦',
          iconClass: 'icon-7',
          link: '/attach/direct-to-consumer-brands'
        },
        {
          name: 'Apparel & Footwear',
          icon: '👠',
          iconClass: 'icon-1',
          link: '/attach/apparel-and-footwear'
        },
        {
          name: 'Working with Influencers',
          icon: '📣',
          iconClass: 'icon-8',
          link: '/attach/working-with-influencers'
        },
        {
          name: 'Food & Beverage',
          icon: '🥤',
          iconClass: 'icon-4',
          link: '/attach/food-and-beverage'
        },
        {
          name: 'Consumer Electronics',
          icon: '📱',
          iconClass: 'icon-3',
          link: '/attach/consumer-electronics'
        }
      ]
    }
  },
  components: {
    Blob
  },
  mounted() {
    // if (!window.sr) window.sr = ScrollReveal()
    // window.sr.reveal('.solutions', { delay: 250, duration: 500 })
  },
  methods: {
    solutionClickEvent(name) {
      eventDispatcher('solutionLinkClicked', {
        solutionName: name
      })
    }
  },
  computed: {},
  watch: {}
}
</script>

<style scoped>

  .solutions {
    display: block;
    margin: 40px 0;
    margin-top: -40px;
  }

  .our-solutions {
    height: 80px;
  }

  .solution-heading {
    font-family: "Work Sans",sans-serif;
    font-weight: normal;
    letter-spacing: 2px;
    font-size: 14px;
    margin: 0 auto;
    display: block;
    text-align: center;
    color: #333;
    text-transform: uppercase;
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .-wrapper {
    display: block;
    margin: 24px auto;
    text-align: center;
  }

  .-item {
    text-decoration: none;
    display: inline-block;
    width: 271px;
    vertical-align: top;
    margin: 24px;
    font-family: "Work Sans", sans-serif;
    font-size: 18px;
    padding: 32px 4px;
    border-radius: 4px;
    /* background: linear-gradient(135deg, #adadad 0%,#bbbbbb 69%,#bbbbbb 100%); */
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    box-shadow: 0 2px 7px rgba(0, 0, 0, 0.07);
    color: #fff;
    cursor: pointer;
    transition: ease-in-out 0.225s;
  }

  .-item:hover {
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    color: white;
  }

  @media only screen and (max-width: 800px) {
    .-item {
      background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
      width: 80%;
      margin: 12px auto;
      padding: 12px 4px;
    }
  }

  .icon {
    font-style: normal;
    font-size: 45px;
    position: absolute;
    margin-top: -16px;
    margin-left: -48px;
    transform: rotate(-6deg);
    text-shadow: 0 1px 15px rgba(0, 0, 0, 0.22);
  }

  .icon-1 {

  }

  .icon-2 {

  }

  .icon-3 {

  }

  .icon-4 {
    font-size: 55px;
    margin-top: -22px;
  }

  .icon-5 {

  }

  .icon-6 {

  }

  .icon-7 {

  }

  .icon-8 {

  }

  .solution-name {
    width: 229px;
    font-size: 16px;
    display: inline-block;
  }

</style>



// WEBPACK FOOTER //
// Solutions.vue?ac220c3c